const defaultOptions = {
  fieldSeparator: ',',
  quoteStrings: true,
  quoteCharacter: '"',
  decimalSeparator: '.',
  showColumnHeaders: true,
  useBom: true,
  useKeysAsHeaders: true,
  filename: 'datos',
}

const escapeValue = (value, quoteCharacter, fieldSeparator, quoteStrings) => {
  if (value === null || value === undefined) return ''

  const stringValue = String(value)
  const needsQuotes =
    quoteStrings ||
    stringValue.includes(fieldSeparator) ||
    stringValue.includes(quoteCharacter) ||
    stringValue.includes('\n') ||
    stringValue.includes('\r')

  if (needsQuotes) {
    const escapedValue = stringValue.replace(new RegExp(quoteCharacter, 'g'), quoteCharacter + quoteCharacter)
    return quoteCharacter + escapedValue + quoteCharacter
  }

  return stringValue
}

const generateCsvContent = (data, options) => {
  const config = { ...defaultOptions, ...options }
  const { fieldSeparator, quoteCharacter, quoteStrings, showColumnHeaders, useKeysAsHeaders } = config

  if (!data || data.length === 0) return ''

  const headers = useKeysAsHeaders ? Object.keys(data[0]) : []
  const rows = []

  // Add headers
  if (showColumnHeaders && headers.length > 0) {
    const headerRow = headers
      .map((header) => escapeValue(header, quoteCharacter, fieldSeparator, quoteStrings))
      .join(fieldSeparator)
    rows.push(headerRow)
  }

  // Add data rows
  data.forEach((item) => {
    const row = headers
      .map((header) => escapeValue(item[header], quoteCharacter, fieldSeparator, quoteStrings))
      .join(fieldSeparator)
    rows.push(row)
  })

  return rows.join('\n')
}

const downloadCsv = (data, options = {}) => {
  if (!data) {
    throw new Error('No data provided for CSV export')
  }

  const normalizedData = Array.isArray(data) ? data : [data]
  const config = { ...defaultOptions, ...options }

  let csvContent = generateCsvContent(normalizedData, config)

  // Add BOM for Excel compatibility
  if (config.useBom) {
    csvContent = '\uFEFF' + csvContent
  }

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', `${config.filename}.csv`)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // Clean up the URL object
  URL.revokeObjectURL(url)
}

export default downloadCsv
